import React from 'react'

function GradientCircleNotchIcon({ width = '24', height = '24' }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="animate-spin"
    >
      <defs>
        <linearGradient id="spinner-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#8B5CF6" stopOpacity="1" />
          <stop offset="50%" stopColor="#A855F7" stopOpacity="0.8" />
          <stop offset="100%" stopColor="#C084FC" stopOpacity="0.6" />
        </linearGradient>
      </defs>

      <circle
        cx="12"
        cy="12"
        r="10"
        stroke="url(#spinner-gradient)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeDasharray="60 20"
        fill="none"
        opacity="0.3"
      />

      <circle
        cx="12"
        cy="12"
        r="10"
        stroke="#8B5CF6"
        strokeWidth="2"
        strokeLinecap="round"
        strokeDasharray="15 65"
        fill="none"
        className="animate-pulse"
      />
    </svg>
  )
}
export default GradientCircleNotchIcon
